import Swiper, { Navigation, Scrollbar } from 'swiper/core';
Swiper.use([Navigation, Scrollbar]);

export default class SliderSectionSlider {
    constructor(elm, args) {
        if (elm.querySelectorAll('.swiper-slide').length === 0) return;

        let nextArrow = elm.parentNode.querySelector('.swiper-button-next');
        let prevArrow = elm.parentNode.querySelector('.swiper-button-prev');

        let options = {
            spaceBetween: args?.spaceBetween,
            allowTouchMove: true,
            slidesPerView: args?.slidesPerView,
            navigation: {
                nextEl: nextArrow,
                prevEl: prevArrow,
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                snapOnRelease: true,
            },
        };

        let swiper = new Swiper(elm, options);
    }

    update() {
        this.swiper.update();
    }

    destroy() {
        this.swiper.destroy();
    }
}
